import {useSelector} from 'react-redux';
import {attendedWithCourse} from 'constants/url';
import authFetch from '../../../helpers/requests';

function useLoadNotification(user: string, role: string) {
  const cwid = useSelector((state: any) => state.authentication.user.name);
  const loadAttended = useLoad(attendedWithCourse, user, cwid, role);
  return () => loadAttended();
}

function useLoad(url: string, additional: string, cwid: string, role: string) {
  const token: string = useSelector(
    (state: any) => state.authentication.user.token,
  );
  return () =>
    authFetch(
      `${url}?cwid=${cwid}&switchParam=${additional}&role=${role}`,
      {mode: 'cors'},
      token,
    )
      .then((response: any) => response.text())
      .then((data) => (data ? JSON.parse(data) : {}))
      .catch((e) => {
        return {};
      });
}

export default useLoadNotification;
